import { Admin as AdminTypes } from '../../types'

const {
  ADMIN_REQUEST_FETCH_ARTICLES,
  ADMIN_REQUEST_CREATE_ARTICLE,
  ADMIN_REQUEST_UPDATE_ARTICLE,
  ADMIN_REQUEST_DELETE_ARTICLE,
  ADMIN_ACTION_ARTICLE_SUCCESS,
  ADMIN_ACTION_ARTICLE_ERROR,
  ADMIN_RESET_ARTICLE
} = AdminTypes.article

const initialState = {
  articles: [],
  isLoading: false,
  errors: {
    status: false,
    message: null
  }
}

export default (state = initialState, action) => {
  switch (action.type) {

    case ADMIN_ACTION_ARTICLE_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          status: true,
          message: action.payload.message
        }
      }

    case ADMIN_ACTION_ARTICLE_SUCCESS:
      return {
        ...state,
        articles: action.payload.articles,
        isLoading: false,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case ADMIN_REQUEST_FETCH_ARTICLES:
    case ADMIN_REQUEST_CREATE_ARTICLE:
    case ADMIN_REQUEST_UPDATE_ARTICLE:
    case ADMIN_REQUEST_DELETE_ARTICLE:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case ADMIN_RESET_ARTICLE:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    default:
      return state

  }
}
